import { state } from '../map_state/state'
import { Renderer } from '../renderer'
import { callMethodOnKeydown, isTyping } from '../helpers'
import { loader } from '../map_state/loader'
import { pathTracerTool } from './path_tracer_tool'
import { UnitConverter } from '../unit_converter'
import { historyTool } from './history_tool'

class CalculateDimensionsTool {
  constructor () {
    this.element = document.getElementById('mct-calculate-dimensions-button')
    this.distanceElement = document.getElementById('mct-dimensions-distance')
    this.unitElement = document.getElementById('mct-dimensions-unit')
    this.widthValue = document.getElementById('mct-width-value')
    this.lengthValue = document.getElementById('mct-length-value')
    this.swapUnitElement = document.getElementById('mct-swap-unit')
    this.toggleVisibility()
    this.bindEvents()
  }

  bindEvents () {
    this.onKeyDown = this.onKeyDown.bind(this)
    this.calculate = this.calculate.bind(this)
    this.swapMeasurement = this.swapMeasurement.bind(this)
    this.element.addEventListener('click', this.calculate)
    this.swapUnitElement.addEventListener('click', this.swapMeasurement)
    document.addEventListener('keydown', this.onKeyDown)
  }

  unBindEvents () {
    this.element.removeEventListener('click', this.calculate)
    this.swapUnitElement.removeEventListener('click', this.swapMeasurement)
    document.removeEventListener('keydown', this.onKeyDown)
  }

  onKeyDown (e) {
    if (isTyping(e.target)) return
    if (e.key === 'b' && state.lenPath) callMethodOnKeydown(e.target, this.calculate)
    if (e.key === 'y' && state.lenPath) callMethodOnKeydown(e.target, this.swapMeasurement)
  }

  calculate () {
    if (!state.mapImage) {
      loader.setStatusMessage('failure', 'Please upload a map image to calculate dimensions.')
      return
    }

    const tracedLength = Number(state.lenPath)
    const enteredDistance = Number(this.distanceElement.value)

    if (!Number.isFinite(tracedLength) || tracedLength <= 0) {
      loader.setStatusMessage('failure', 'Please trace a valid path before calculating dimensions.')
      return
    }

    if (!Number.isFinite(enteredDistance) || enteredDistance <= 0) {
      loader.setStatusMessage('failure', 'Please enter a valid distance.')
      return
    }

    state.lenPath = enteredDistance / tracedLength
    state.lenUnit = this.unitElement.value
    state.calibration = true

    pathTracerTool.removePath()
    this.updateFields()

    for (const s of state.sensors) {
      s.ensureDefaults(true)
      s.enableRanges()
    }

    this.distanceElement.value = 0
    historyTool.add()
    Renderer.render()
  }

  updateFields () {
    const round1 = v => Math.round(v * 10) / 10

    this.widthValue.textContent =
            Number.isFinite(state.lenPath) ? round1(state.mapImage.naturalWidth * state.lenPath) : '--'

    this.lengthValue.textContent =
            Number.isFinite(state.lenPath) ? round1(state.mapImage.naturalHeight * state.lenPath) : '--'

    if (this.unitElement && state.lenUnit) {
      this.unitElement.value = state.lenUnit
    }

    document.querySelectorAll('.mct-numerical-unit').forEach(el => {
      el.textContent = state.lenUnit ? state.lenUnit : 'm'
    })

    this.toggleVisibility()
  }

  swapMeasurement () {
    if (!Number.isFinite(Number(state.lenPath)) || !state.lenUnit) return

    const from = state.lenUnit
    const to = state.lenUnit === 'm' ? 'ft' : 'm'

    state.lenUnit = to
    state.lenPath = Number(UnitConverter.convert(state.lenPath, from, to))
    this.unitElement.value = to

    for (const s of state.sensors) {
      s.ensureDefaults(true)
      s.enableRanges()
    }

    this.updateFields()
    historyTool.add()
    Renderer.render()
  }

  resetDimensions () {
    state.mapUnitLength = '--'
    state.mapUnitWidth = '--'
    this.widthValue.textContent = state.mapUnitWidth
    this.lengthValue.textContent = state.mapUnitLength
    if (this.unitElement) this.unitElement.value = 'm'
    document.querySelectorAll('.mct-numerical-unit').forEach(el => el.textContent = 'm')
    this.toggleVisibility()
  }

  toggleVisibility () {
    this.swapUnitElement.classList.toggle('hidden', !state.calibration)
  }
}

export let pathcalculatorTool = null

export function initPathcalculatorTool () {
  pathcalculatorTool = new CalculateDimensionsTool()
  return pathcalculatorTool
}
